
export const getBackgroundByCondition = (spread) => {
    spread = +spread;

    if (spread <= 4) {
        return `#00D2AB`
    } else if (spread > 4 && spread <= 10) {
        return `#0070DD`
    } else if (spread > 10 && spread <= 30) {
        return `#A335EE`
    } else {
        return `#FF8000`
    }
}